import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";

export const FormMixin = {
    extends: CoreLibrary,

    data() {
        return {
            mixinName: "formMixin",
            fields: {},
            fieldStatus: {
                isSubmit: false,
            },
        };
    },

    methods: {
        changed() {
        }
    }
};